import { sendToURL } from 'amkit3-modules/utils/ajax'
import { STATISTIC_PLAYSTATS } from 'amkit3-modules/utils/services/urls'

export const playStats = (
  vid,
  channelId,
  laiyuanv3,
  stats_key,
  source_url,
  referrer_url,
  content,
  remark,
) => {
  sendToURL(STATISTIC_PLAYSTATS, {
    r: 'play/stats',
    vid,
    channelId,
    laiyuanv3,
    stats_key,
    source_url,
    referrer_url,
    content,
    remark,
  })
}

export const playLoad = (vid, type, channelId, source_url, referrer, laiyuanv3) => {
  sendToURL(STATISTIC_PLAYSTATS, {
    r: 'play/load',
    vid,
    type,
    channelId,
    source_url,
    referrer,
    laiyuanv3,
  })
}

export const playDo = (vid, type, channelId, source_url, referrer, laiyuanv3) => {
  sendToURL(STATISTIC_PLAYSTATS, {
    r: 'play/do',
    vid,
    type,
    channelId,
    source_url,
    referrer,
    laiyuanv3,
  })
}
export default {
  playStats,
  playLoad,
  playDo,
}
